export default __webpack_public_path__ + "static/media/chevron-forward.6b815895.svg";